/*global process */
import $ from 'jquery';

// Determine the host based on startup mode set in config/env
export const HOST = process.env.REACT_DEV ? process.env.API_HOST : '/';

export function Post(endpoint, data, headers) {
  return Request({ type: 'POST', endpoint, data, headers });
}

export function Put(endpoint, data, headers) {
  return Request({ type: 'PUT', endpoint, data, headers });
}

export function Get(endpoint, headers) {
  return Request({ type: 'GET', endpoint, headers });
}

export function Delete(endpoint, headers) {
  return Request({ type: 'DELETE', endpoint, headers });
}

/**
 * Createa an ajax request
 * @param {string} type : request method type
 * @param {string} endpoint : the url of the request
 * @param {object} data : the data for to be sent as json request body
 * @param {object} headers : headers to add
 * @returns  Promise of the response.
 */
const Request = ({
  type,
  endpoint,
  data = {},
  headers = undefined
}) => {
  const url = HOST + endpoint;

  return new Promise((resolve, reject) => {
    if (!url.includes('sapi'))
    {
      // the 'sapi' route is used here over 'api' to allow
      // all front-end traffic to be redirected over https
      // ! All endpoints hit must be over sapi to avoid
      // ! disguising http traffic as https
      reject('Endpoint not routed over expected \'sapi\' path');
    }

    $.ajax({
      url,
      headers,
      data: JSON.stringify(data),
      contentType: 'application/json',
      method: type,
      success: (response) => {
        resolve(response);
      },
      error: (xhr, _status, error) => {
        if (xhr.responseText) {
          // usually non-auth error responses from our backend controllers land here
          // we provide responseText by convention
          if (process.env.REACT_DEV) {
            console.log('DevOnly_AjaxRejectOnResponseText:', type, url, xhr.responseText);
          }
          reject(xhr.responseText);
        } else {
          // errors generated from external factors or from builtin NetCore mechanics
          // land here. This includes endpoints blocked on AuthorizeAttributes
          // through our middleware.
          if (process.env.REACT_DEV) {
            console.log('DevOnly_AjaxRejectOnError:', type, url, error);
          }
          reject(error);
        }
      }
    });
  });
};

export const HTTPSTATUSCODE = {
  OK: 200,
  UNAUTHORIZED: 401
};


// WEBPACK FOOTER //
// src/helpers/ajax.js